import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Elements, StripeProvider } from 'react-stripe-elements';
import { stripeNonSecretKey } from 'Consts/keys';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  useSubscriptionSetupContext,
} from 'Views/Onboarding/Pages/SubscriptionSetup/SubscriptionSetupContext';
import OnboardingHeader from 'Views/Onboarding/Components/Header';
import SubscriptionPaymentSummary from './SubscriptionPaymentSummary';
import CreditCardForm from './CreditCardForm';

const styles = () => ({
  root: {},
  rootHidden: { display: 'none' },
});

const SubscriptionSetupInitial = ({
  className,
  classes,
  hidden,
}) => {
  const { billingInformationCollection } = useSubscriptionSetupContext();

  useScrollTopOnMount();

  return (
    <Box
      className={classNames(classes.root, className, {
        [classes.rootHidden]: hidden,
      })}
    >
      {/* -------- Main Header -------- */}
      <OnboardingHeader
        title={'Payment'}
        subTitle={'Please enter your credit card details'}
        centered
      />

      {/* -------- Payment summary -------- */}
      <SubscriptionPaymentSummary
        billingInformationCollection={billingInformationCollection}
      />

      <StripeProvider apiKey={stripeNonSecretKey}>
        <Elements>
          <CreditCardForm />
        </Elements>
      </StripeProvider>
    </Box>
  );
};

SubscriptionSetupInitial.defaultProps = {
  className: '',
};

SubscriptionSetupInitial.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  hidden: PropTypes.bool.isRequired,
};

export default withStyles(styles)(SubscriptionSetupInitial);
